
.spectrum-Toolbar {
    display: flex;
    gap: 8px;
    width: fit-content;
    &[data-orientation="vertical"] {
        flex-direction: column;
    }
    &[data-orientation="horizontal"] {
        flex-direction: row;
    }
}
